import React from 'react';
import { AppGridLayout, AppTableSearch, AppTable, AppRow, AppButton, AppSearchItem } from 'qcc';
import { AppAction, AppGridBar } from 'qcc';
import api, { PosProjectFundVo, PosProjectFundTax, PosProjectFundReplace } from "api";
import SetReplaceForm from './SetReplaceForm'

export default class extends React.Component {
  state = { projectId: 0 }

  onSearch = async (filterList?: any[], data?: any) => {
    let projectId = data.projectId || 0;
    this.setState({ projectId }, this.fetchTable)
  }


  fetchTable = async () => {
    let { projectId } = this.state;

    let list = await api.posprojectfund.getProjectFundVoList({ projectId });
    this.refGrid.current && this.refGrid.current.setDataSource(list);
  }

  afterSave = () => {
    this.fetchTable();
    AppAction.closeDialog();
  }

  setTax = async (data?: PosProjectFundVo) => {
    let { projectId } = this.state;
    if (projectId === 0) return;

    if (await AppAction.confirm('您确定要将该款项设置为不计税吗？')) {
      let { id, taxId } = data;
      let posProjectFundTax: PosProjectFundTax = { id: taxId, fundId: id, isTax: 1, projectId };
      await api.posprojectfund.setProjectFundTax(posProjectFundTax);
      AppAction.successMsg('操作成功！');
      this.fetchTable();
    }
  }

  cancelTax = async (data?: PosProjectFundVo) => {
    let { projectId } = this.state;
    if (projectId === 0) return;

    if (await AppAction.confirm('您确定要取消将该款项设置为不计税吗？')) {
      let { id, taxId } = data;
      let posProjectFundTax: PosProjectFundTax = { id: taxId, fundId: id, isTax: 0, projectId };
      await api.posprojectfund.setProjectFundTax(posProjectFundTax);
      AppAction.successMsg('操作成功！');
      this.fetchTable();
    }
  }

  setReplaceName = async (data?: PosProjectFundVo) => {
    let { projectId } = this.state;
    let { id, replaceId, replaceName, name } = data;
    replaceId = replaceId === 0 ? null : replaceId;
    let posProjectFundReplace = { id: replaceId, fundId: id, replaceName, projectId, name };
    let title = '设置票据打印名称'
    let editForm = <SetReplaceForm mode={1} formData={posProjectFundReplace} afterSave={this.afterSave} />
    AppAction.openDialog(editForm, { title, height: 260, width: 500 });
  }

  cancelReplaceName = async (data?: PosProjectFundVo) => {
    let { projectId } = this.state;
    if (projectId === 0) return;

    if (await AppAction.confirm('您确定要取消将该款项票据别名吗？')) {
      let { id, replaceId } = data;
      let posProjectFundReplace: PosProjectFundReplace = { id: replaceId, fundId: id, replaceName: '', projectId };
      await api.posprojectfund.setReplaceName(posProjectFundReplace);
      AppAction.successMsg('操作成功！');
      this.fetchTable();
    }
  }



  refGrid = React.createRef<AppTable>();

  render() {
    return (
      <AppGridLayout >
        <AppGridLayout.SearchArea>
          <AppTableSearch onSearch={this.onSearch}>
            <AppTableSearch.Common>
              <AppSearchItem.ProjectTree keyName='projectId' projectTreeScene={6601} field='project_id' lable='项目：' />
            </AppTableSearch.Common>
          </AppTableSearch>
        </AppGridLayout.SearchArea>
        <AppGridLayout.GridArea>
          <AppTable paging={false} ref={this.refGrid} >
            <AppTable.ColIndex />
            <AppTable.Col title='款项类型\名称' expand field='name' width={200} />
            <AppTable.Col title='票据别名' field='replaceName' width={150} />
            <AppTable.Col title='是否计税' width={80} align='center' render={(data?: any, dataIndex?: number) => {
              return data.isTax === 1 ? '否' : '';
            }} />

            <AppTable.ColAction render={(data: any, dataIndex: number) => {
              let { mode, replaceName, isTax } = data;
              return (<AppRow itemSplit={10} style={{ float: 'right', marginRight: 20 }}>
                {mode === 1 && replaceName === '' ? <AppButton label='设置款项打印别名' actionCode="66101801" type='link' action={() => this.setReplaceName(data)} /> : null}
                {mode === 1 && replaceName !== '' ? <AppButton label='取消款项打印别名' actionCode="66101801" type='link' action={() => this.cancelReplaceName(data)} /> : null}
                {mode === 1 && isTax === 0 ? <AppButton label='设置为不计税' actionCode="66101802" type='link' action={() => this.setTax(data)} /> : null}
                {mode === 1 && isTax === 1 ? <AppButton label='取消设置不计税' actionCode="66101802" type='link' action={() => this.cancelTax(data)} /> : null}
              </AppRow>);
            }} />
          </AppTable>
        </AppGridLayout.GridArea>
      </AppGridLayout>
    )
  }
}


// WEBPACK FOOTER //
// ./src/page/pos/projectfund/index.tsx